// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error) {
        const { onError } = this.props;
        onError(error);
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        return hasError ? <h1>Something went wrong.</h1> : children;
    }
}

ErrorBoundary.propTypes = {
    onError: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};
